import axios from 'axios';
import { clearSession, getExpiresAt, getToken, isExpired } from '../services/auth';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

client.interceptors.request.use((config) => {
  const token = getToken();
  const expiresAt = getExpiresAt();

  if (token && expiresAt && !isExpired(expiresAt)) {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    const hasToken = !!getToken();

    if (!error.response) {
      clearSession();
      window.location.href = '/';
    }
    return Promise.reject(error);
  },
);

export default client;

